<template>
    <div>
        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('reserve_hold_by') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="reserve_hold_by"
                    @change="(val) => onchange('reserve_hold_by',val)"
                    :hint="`${reserve_hold_by.desc}`"
                    :items="reserve_hold_by_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('reserve_accept_by') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="reserve_accept_by"
                    @change="(val) => onchange('reserve_accept_by',val)"
                    :hint="`${reserve_accept_by.desc}`"
                    :items="reserve_accept_by_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('reserve_count_mode') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="reserve_count_mode"
                    @change="(val) => onchange('reserve_count_mode',val)"
                    :hint="`${reserve_count_mode.desc}`"
                    :items="reserve_count_mode_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('reserve_activated_callback') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="reserve_activated_callback"
                    @change="(val) => onchange('reserve_activated_callback',val)"
                    :hint="`${reserve_activated_callback.desc}`"
                    :items="reserve_activated_callback_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                เจ้าหน้าที่ทำนัดหมายได้ล่วงหน้า
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="appointment_aftermin"
                    @change="appointment_aftermin_change"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-select
                    :value="appointment_aftermin_type"
                    @change="(val)=>{appointment_aftermin = 0;appointment_aftermin_type=val;}"
                    :items="minhrday_items"
                    item-text="name"
                    item-value="val"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
            <v-col cols="12" md="1" align="left" class="pt-6">
                ไม่เกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="appointment_beforemin"
                    @change="appointment_beforemin_change"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-select
                    :value="appointment_beforemin_type"
                    @change="(val)=>{appointment_beforemin = 0;appointment_beforemin_type=val;}"
                    :items="minhrday_items"
                    item-text="name"
                    item-value="val"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                สมาชิกจองล่วงหน้าได้
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reservation_aftermin"
                    @change="reservation_aftermin_change"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-select
                    :value="reservation_aftermin_type"
                    @change="(val)=>{reservation_aftermin = 0;reservation_aftermin_type=val;}"
                    :items="minhrday_items"
                    item-text="name"
                    item-value="val"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
            <v-col cols="12" md="1" align="left" class="pt-6">
                ไม่เกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reservation_beforemin"
                    @change="reservation_beforemin_change"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-select
                    :value="reservation_beforemin_type"
                    @change="(val)=>{reservation_beforemin = 0;reservation_beforemin_type=val;}"
                    :items="minhrday_items"
                    item-text="name"
                    item-value="val"
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="3" align="left" class="pt-6">
                เปิดให้จองเพื่อมารับบริการได้ในวันที่
            </v-col>
            <v-col cols="3" align="left">
                <v-menu
                    v-model="date_menu_calendar_startdate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateof_reserve_calendar_startdate"
                    prepend-icon="event"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                    v-model="dateof_reserve_calendar_startdate" 
                    @input="(val) => {date_menu_calendar_startdate = false;onchange('reserve_calendar_startdate',val);}"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1" align="left" class="pt-6">
                ถึงวันที่
            </v-col>
            <v-col cols="3" align="left">
                <v-menu
                    v-model="date_menu_calendar_enddate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateof_reserve_calendar_enddate"
                    prepend-icon="event"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                    v-model="dateof_reserve_calendar_enddate" 
                    @input="(val) => {date_menu_calendar_enddate = false;onchange('reserve_calendar_enddate',val);}"
                ></v-date-picker>
              </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="3" align="left" class="pt-6">
                เปิดให้เริ่มกดเข้ามาใช้ระบบจองตั้งแต่
            </v-col>
            <v-col cols="2" align="left">
                <v-menu
                    v-model="date_menu_enable_startdate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateof_reserve_enable_startdate"
                    prepend-icon="event"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                    v-model="dateof_reserve_enable_startdate" 
                    @input="(val) => {date_menu_enable_startdate = false;updateEnableStartDateTime();}"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" align="left">
                <v-select
                    v-model="timeof_reserve_enable_startdate" 
                    :items="timelist"
                    @change="updateEnableStartDateTime"
                    outlined
                    dense
                    
                >
                </v-select>
            </v-col>
            <v-col cols="1" align="left" class="pt-6">
                ถึง
            </v-col>
            <v-col cols="2" align="left">
                <v-menu
                    v-model="date_menu_enable_enddate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateof_reserve_enable_enddate"
                    prepend-icon="event"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                    v-model="dateof_reserve_enable_enddate" 
                    @input="(val) => {date_menu_enable_enddate = false;updateEnableEndDateTime();}"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" align="left">
                <v-select
                    v-model="timeof_reserve_enable_enddate" 
                    :items="timelist"
                    @change="updateEnableEndDateTime"
                    outlined
                    dense
                    
                >
                </v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                กลุ่มงานบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_month_dup_day"
                    @change="(val) => onchange('reserve_month_dup_day',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายในวันเดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                กลุ่มงานบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_month_dup_week"
                    @change="(val) => onchange('reserve_month_dup_week',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายในสัปดาห์เดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                กลุ่มงานบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_month_dup_month"
                    @change="(val) => onchange('reserve_month_dup_month',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายเดือนวันเดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                กลุ่มงานบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_month_dup_all"
                    @change="(val) => onchange('reserve_month_dup_all',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง รวมทั้งหมด
            </v-col>
        </v-row>

    </div>
</template>

<script>

  export default {
    props: [
        'reserve_hold_by'
        ,'reserve_hold_by_items'
        ,'reserve_accept_by'
        ,'reserve_accept_by_items'
        ,'reserve_count_mode'
        ,'reserve_count_mode_items'
        ,'reservation_after'
        ,'reservation_before'
        ,'reserve_activated_callback'
        ,'reserve_activated_callback_items'
        ,'appointment_aftermin'
        ,'appointment_beforemin'
        ,'appointment_aftermin_type'
        ,'appointment_beforemin_type'
        ,'reservation_aftermin'
        ,'reservation_beforemin'
        ,'reservation_aftermin_type'
        ,'reservation_beforemin_type'
        ,'onchange'
        ,'disabled'
        ,'reserve_month_dup_day'
        ,'reserve_month_dup_week'
        ,'reserve_month_dup_month'
        ,'reserve_month_dup_all'
        ,'reserve_calendar_startdate'
        ,'reserve_calendar_enddate'
        ,'reserve_enable_startdate'
        ,'reserve_enable_enddate'
    ],
    data () {
        return {
            timelist : [0,30,100,130,200,230,300,330,400,430,500,530,600,630,700,730,800,830,900,930,1000,1030,1100,1130,1200,1230,1300,1330,1400,1430,1500,1530,1600,1630,1700,1730,1800,1830,1900,1930,2000,2030,2100,2130,2200,2230,2300,2330,2359],
            dateof_reserve_calendar_startdate : null,
            dateof_reserve_calendar_enddate : null,
            dateof_reserve_enable_startdate : null,
            dateof_reserve_enable_enddate : null,
            timeof_reserve_enable_startdate : null,
            timeof_reserve_enable_enddate : null,
            date_menu_calendar_enddate : false,
            date_menu_calendar_startdate : false,
            date_menu_enable_enddate : false,
            date_menu_enable_startdate : false,
            minhrday_items : [{name:"นาที",val:"min"},{name:"ชั่วโมง",val:"hr"},{name:"วัน",val:"day"}],
        }
    },
    mounted : function () {
        this.timelist = this.timelistToItems(this.timelist)
        this.dateof_reserve_calendar_startdate = this.reserve_calendar_startdate
        this.dateof_reserve_calendar_enddate = this.reserve_calendar_enddate
        if(this.reserve_enable_startdate.length>0){
            this.dateof_reserve_enable_startdate = this.reserve_enable_startdate.split(' ')[0]
            this.timeof_reserve_enable_startdate = this.reserve_enable_startdate.split(' ')[1]
        }
        if(this.reserve_enable_enddate.length>0){
            this.dateof_reserve_enable_enddate = this.reserve_enable_enddate.split(' ')[0]
            this.timeof_reserve_enable_enddate = this.reserve_enable_enddate.split(' ')[1]
        }
    },
    methods: {
        updateEnableEndDateTime(){
            if(this.timeof_reserve_enable_enddate == null){
                this.timeof_reserve_enable_enddate = this.timelist[0]
            }
            if(this.dateof_reserve_enable_enddate == null){
                var date = new Date()
                date.setHours(date.getHours()+7)
                this.dateof_reserve_enable_enddate = date.toISOString().substr(0, 10)
            }
            var val = this.dateof_reserve_enable_enddate + ' ' + this.timeof_reserve_enable_enddate
            this.onchange('reserve_enable_enddate',val)
        },
        updateEnableStartDateTime(){
            if(this.timeof_reserve_enable_startdate == null){
                this.timeof_reserve_enable_startdate = this.timelist[0]
            }
            if(this.dateof_reserve_enable_startdate == null){
                var date = new Date()
                date.setHours(date.getHours()+7)
                this.dateof_reserve_enable_startdate = date.toISOString().substr(0, 10)
            }
            var val = this.dateof_reserve_enable_startdate + ' ' + this.timeof_reserve_enable_startdate
            this.onchange('reserve_enable_startdate',val)
        },
        timelistToItems(timelist){
                return timelist.map(i=>{
                    if(i<0){
                        return {
                            txt : this.$i18n.t('select_time_all')
                            ,val : i
                        }
                        
                    }
                    var t = '0000' + i
                    return t.substring(t.length-4,t.length-2) + ":" + t.substring(t.length-2,t.length)
                })
            },
      appointment_aftermin_change(val){
        this.appointment_aftermin = val
        if(this.appointment_aftermin_type=='min'){
            this.onchange('appointment_aftermin',val)
        }else if(this.appointment_aftermin_type=='hr'){
            this.onchange('appointment_aftermin',val*60)
        }else if(this.appointment_aftermin_type=='day'){
            this.onchange('appointment_aftermin',val*60*24)
        }
      },
      appointment_beforemin_change(val){
        this.appointment_beforemin = val
        if(this.appointment_beforemin_type=='min'){
            this.onchange('appointment_beforemin',val)
        }else if(this.appointment_beforemin_type=='hr'){
            this.onchange('appointment_beforemin',val*60)
        }else if(this.appointment_beforemin_type=='day'){
            this.onchange('appointment_beforemin',val*60*24)
        }
      },
      reservation_aftermin_change(val){
        this.reservation_aftermin = val
        if(this.reservation_aftermin_type=='min'){
            this.onchange('reservation_aftermin',val)
        }else if(this.reservation_aftermin_type=='hr'){
            this.onchange('reservation_aftermin',val*60)
        }else if(this.reservation_aftermin_type=='day'){
            this.onchange('reservation_aftermin',val*60*24)
        }
      },
      reservation_beforemin_change(val){
        this.reservation_beforemin = val
        if(this.reservation_beforemin_type=='min'){
            this.onchange('reservation_beforemin',val)
        }else if(this.reservation_beforemin_type=='hr'){
            this.onchange('reservation_beforemin',val*60)
        }else if(this.reservation_beforemin_type=='day'){
            this.onchange('reservation_beforemin',val*60*24)
        }
      }
    }
  }
</script>